define('OutSystems/ClientRuntime/modules/Database/WebSQL/WebSQLUtils',["require", "exports", "../../../Exceptions", "../../../RegExpHelper"], function (require, exports, Exceptions_1, RegExpHelper) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getAttributeFromOrderBy = exports.validateQueryOrderBy = exports.getOrderByColumnsWithoutDuplicates = exports.replaceEntityReferencesInOrderBy = void 0;
    function replaceEntityReferencesInOrderBy(paramValue, entityNames, entityAliases) {
        var ret = null;
        var mc = null;
        var m = null;
        var regExpToDetectNotAllowedPrefix = '(^|\\s|\\.)(\\[|"|)(ossys_|osltm_|oslog_|osevt_|osusr_|osext_)';
        var regExpToDetectInputDynSort = "((((\\{\\w+\\})|(\\w+)).)?((\\[\\w+\\])|(\\w+))(( )+(desc|asc))?)(( )*,( )*(((\\{\\w+\\})|(\\w+)).)?((\\[\\w+\\])|(\\w+))(( )+(desc|asc))?)*";
        paramValue = paramValue.trim();
        mc = RegExpHelper.matches(paramValue, regExpToDetectNotAllowedPrefix, true);
        if (mc.length > 0) {
            m = mc[0];
            throw new Exceptions_1.Exceptions.DataBaseException("", "'".concat(m.groups[2] + m.groups[3], "' found in 'Order By' parameter is a reserved prefix"));
        }
        if (paramValue !== "") {
            mc = RegExpHelper.matches(paramValue, regExpToDetectInputDynSort, true);
            if (mc.length !== 1 || mc[0].value !== paramValue) {
                throw new Exceptions_1.Exceptions.DataBaseException("", "Invalid syntax in 'Order By' parameter.");
            }
        }
        var meReplaceEntityName = function (match) {
            return replaceEntityNameInOrderBy(match, entityNames, entityAliases);
        };
        var meReplaceAttributeName = function (match) {
            return replaceAttributeName(match);
        };
        ret = RegExpHelper.replace(paramValue, "(\\{\\w+\\}|\\w+\\.)", false, meReplaceEntityName);
        ret = RegExpHelper.replace(ret, "(\\[\\w+\\])", false, meReplaceAttributeName);
        return ret;
    }
    exports.replaceEntityReferencesInOrderBy = replaceEntityReferencesInOrderBy;
    function replaceEntityNameInOrderBy(m, entityNames, entityAliases) {
        var result = "";
        var entityName = getEntityNameFromMatch(m);
        var found = false;
        for (var i = 0; i < entityNames.length; i++) {
            if (entityNames[i].toLowerCase() === entityName.toLowerCase()) {
                found = true;
                result = '"' + entityAliases[i] + '"';
                break;
            }
        }
        if (!found) {
            throw new Exceptions_1.Exceptions.DataBaseException("", "'".concat(entityName, "' found in 'Order By' parameter is an invalid Entity"));
        }
        if (m.value.charAt(m.value.length - 1) === ".") {
            return result + ".";
        }
        else {
            return result;
        }
    }
    function replaceAttributeName(m) {
        var result = m.value.substr(1, m.value.length - 2);
        return !result
            ? ""
            : (result.charAt(0) === '"' ? "" : '"') + result + (result.charAt(result.length - 1) === '"' ? "" : '"');
    }
    function getEntityNameFromMatch(m) {
        if (m.value.charAt(m.value.length - 1) === ".") {
            return m.value.substr(0, m.value.length - 1);
        }
        else {
            return m.value.substr(1, m.value.length - 2);
        }
    }
    function getOrderByColumnsWithoutDuplicates(orderByColumns) {
        return filterDuplicateOrderByColumns(orderByColumns).join(", ");
    }
    exports.getOrderByColumnsWithoutDuplicates = getOrderByColumnsWithoutDuplicates;
    function filterDuplicateOrderByColumns(orderByColumns) {
        var result = [];
        var usedColumns = {};
        orderByColumns.forEach(function (col) {
            var trimmed = col.trim();
            if (trimmed !== "") {
                var invariant = trimmed
                    .replace(new RegExp("\b((ASC)|(DESC))$", "im"), "")
                    .replace('"', "")
                    .replace("[", "")
                    .replace("]", "")
                    .trim()
                    .toLowerCase();
                if (usedColumns[invariant] !== true) {
                    result.push(trimmed);
                    usedColumns[invariant] = true;
                }
            }
        });
        return result;
    }
    function validateQueryOrderBy(entitiesInfo, orderByColumns) {
        orderByColumns.forEach(function (orderBy) {
            var attr = getAttributeFromOrderBy(orderBy);
            for (var index = 0; index < entitiesInfo.length; index++) {
                var ent = entitiesInfo[index];
                if (ent.attributes.some(function (at) { return at.name.toLowerCase() === attr.toLowerCase(); })) {
                    return true;
                }
            }
            throw new Exceptions_1.Exceptions.DataBaseException("", "Invalid attribute in 'Order By' parameter: ".concat(orderBy));
        });
        return true;
    }
    exports.validateQueryOrderBy = validateQueryOrderBy;
    function getAttributeFromOrderBy(orderBy) {
        var parts = orderBy.trim().split(" ");
        var attrParts = parts[0].split(".");
        return attrParts[attrParts.length - 1].replace(/["]+/g, "");
    }
    exports.getAttributeFromOrderBy = getAttributeFromOrderBy;
});
//# sourceMappingURL=WebSQLUtils.js.map;
